[
  {
    "code": "PT-14-AB",
    "name": "Abrantes"
  },
  {
    "code": "PT-09-AB",
    "name": "Aguiar da Beira"
  },
  {
    "code": "PT-07-AL",
    "name": "Alandroal"
  },
  {
    "code": "PT-01-AL",
    "name": "Albergaria-a-Velha"
  },
  {
    "code": "PT-08-AB",
    "name": "Albufeira"
  },
  {
    "code": "PT-14-AC",
    "name": "Alcanena"
  },
  {
    "code": "PT-10-AC",
    "name": "Alcobaça"
  },
  {
    "code": "PT-15-AC",
    "name": "Alcochete"
  },
  {
    "code": "PT-08-AC",
    "name": "Alcoutim"
  },
  {
    "code": "PT-15-AS",
    "name": "Alcácer do Sal"
  },
  {
    "code": "PT-11-AL",
    "name": "Alenquer"
  },
  {
    "code": "PT-04-AF",
    "name": "Alfândega da Fé"
  },
  {
    "code": "PT-17-AL",
    "name": "Alijó"
  },
  {
    "code": "PT-08-AJ",
    "name": "Aljezur"
  },
  {
    "code": "PT-02-AJ",
    "name": "Aljustrel"
  },
  {
    "code": "PT-15-AM",
    "name": "Almada"
  },
  {
    "code": "PT-09-AL",
    "name": "Almeida"
  },
  {
    "code": "PT-14-AM",
    "name": "Almeirim"
  },
  {
    "code": "PT-02-AM",
    "name": "Almodôvar"
  },
  {
    "code": "PT-14-AP",
    "name": "Alpiarça"
  },
  {
    "code": "PT-12-AC",
    "name": "Alter do Chão"
  },
  {
    "code": "PT-10-AV",
    "name": "Alvaiázere"
  },
  {
    "code": "PT-02-AV",
    "name": "Alvito"
  },
  {
    "code": "PT-11-AM",
    "name": "Amadora"
  },
  {
    "code": "PT-13-AM",
    "name": "Amarante"
  },
  {
    "code": "PT-03-AM",
    "name": "Amares"
  },
  {
    "code": "PT-01-AN",
    "name": "Anadia"
  },
  {
    "code": "PT-20-AH",
    "name": "Angra do Heroísmo"
  },
  {
    "code": "PT-10-AN",
    "name": "Ansião"
  },
  {
    "code": "PT-16-AV",
    "name": "Arcos de Valdevez"
  },
  {
    "code": "PT-06-AR",
    "name": "Arganil"
  },
  {
    "code": "PT-18-AR",
    "name": "Armamar"
  },
  {
    "code": "PT-01-AR",
    "name": "Arouca"
  },
  {
    "code": "PT-07-AR",
    "name": "Arraiolos"
  },
  {
    "code": "PT-12-AR",
    "name": "Arronches"
  },
  {
    "code": "PT-11-AV",
    "name": "Arruda dos Vinhos"
  },
  {
    "code": "PT-01-AV",
    "name": "Aveiro"
  },
  {
    "code": "PT-12-AV",
    "name": "Avis"
  },
  {
    "code": "PT-11-AZ",
    "name": "Azambuja"
  },
  {
    "code": "PT-13-BA",
    "name": "Baião"
  },
  {
    "code": "PT-03-BA",
    "name": "Barcelos"
  },
  {
    "code": "PT-02-BA",
    "name": "Barrancos"
  },
  {
    "code": "PT-15-BA",
    "name": "Barreiro"
  },
  {
    "code": "PT-10-BA",
    "name": "Batalha"
  },
  {
    "code": "PT-02-BE",
    "name": "Beja"
  },
  {
    "code": "PT-05-BE",
    "name": "Belmonte"
  },
  {
    "code": "PT-14-BE",
    "name": "Benavente"
  },
  {
    "code": "PT-10-BO",
    "name": "Bombarral"
  },
  {
    "code": "PT-07-BO",
    "name": "Borba"
  },
  {
    "code": "PT-17-BO",
    "name": "Boticas"
  },
  {
    "code": "PT-03-BR",
    "name": "Braga"
  },
  {
    "code": "PT-04-BR",
    "name": "Bragança"
  },
  {
    "code": "PT-03-CB",
    "name": "Cabeceiras de Basto"
  },
  {
    "code": "PT-11-CD",
    "name": "Cadaval"
  },
  {
    "code": "PT-10-CR",
    "name": "Caldas da Rainha"
  },
  {
    "code": "PT-20-CA",
    "name": "Calheta"
  },
  {
    "code": "PT-30-CT",
    "name": "Calheta"
  },
  {
    "code": "PT-16-CA",
    "name": "Caminha"
  },
  {
    "code": "PT-12-CM",
    "name": "Campo Maior"
  },
  {
    "code": "PT-06-CA",
    "name": "Cantanhede"
  },
  {
    "code": "PT-04-CA",
    "name": "Carrazeda de Ansiães"
  },
  {
    "code": "PT-18-CS",
    "name": "Carregal do Sal"
  },
  {
    "code": "PT-14-CA",
    "name": "Cartaxo"
  },
  {
    "code": "PT-11-CS",
    "name": "Cascais"
  },
  {
    "code": "PT-10-CP",
    "name": "Castanheira de Pêra"
  },
  {
    "code": "PT-05-CB",
    "name": "Castelo Branco"
  },
  {
    "code": "PT-01-CP",
    "name": "Castelo de Paiva"
  },
  {
    "code": "PT-12-CV",
    "name": "Castelo de Vide"
  },
  {
    "code": "PT-18-CD",
    "name": "Castro Daire"
  },
  {
    "code": "PT-08-CM",
    "name": "Castro Marim"
  },
  {
    "code": "PT-02-CV",
    "name": "Castro Verde"
  },
  {
    "code": "PT-09-CB",
    "name": "Celorico da Beira"
  },
  {
    "code": "PT-03-CL",
    "name": "Celorico de Basto"
  },
  {
    "code": "PT-14-CH",
    "name": "Chamusca"
  },
  {
    "code": "PT-17-CH",
    "name": "Chaves"
  },
  {
    "code": "PT-18-CI",
    "name": "Cinfães"
  },
  {
    "code": "PT-06-CO",
    "name": "Coimbra"
  },
  {
    "code": "PT-06-CN",
    "name": "Condeixa-a-Nova"
  },
  {
    "code": "PT-14-CN",
    "name": "Constância"
  },
  {
    "code": "PT-14-CR",
    "name": "Coruche"
  },
  {
    "code": "PT-20-CO",
    "name": "Corvo"
  },
  {
    "code": "PT-05-CO",
    "name": "Covilhã"
  },
  {
    "code": "PT-12-CR",
    "name": "Crato"
  },
  {
    "code": "PT-02-CU",
    "name": "Cuba"
  },
  {
    "code": "PT-30-CL",
    "name": "Câmara de Lobos"
  },
  {
    "code": "PT-12-EL",
    "name": "Elvas"
  },
  {
    "code": "PT-14-EN",
    "name": "Entroncamento"
  },
  {
    "code": "PT-01-EN",
    "name": "Espinho"
  },
  {
    "code": "PT-03-ES",
    "name": "Esposende"
  },
  {
    "code": "PT-01-ER",
    "name": "Estarreja"
  },
  {
    "code": "PT-07-ES",
    "name": "Estremoz"
  },
  {
    "code": "PT-03-FA",
    "name": "Fafe"
  },
  {
    "code": "PT-08-FA",
    "name": "Faro"
  },
  {
    "code": "PT-13-FE",
    "name": "Felgueiras"
  },
  {
    "code": "PT-02-FA",
    "name": "Ferreira do Alentejo"
  },
  {
    "code": "PT-14-FZ",
    "name": "Ferreira do Zêzere"
  },
  {
    "code": "PT-06-FF",
    "name": "Figueira da Foz"
  },
  {
    "code": "PT-09-FC",
    "name": "Figueira de Castelo Rodrigo"
  },
  {
    "code": "PT-10-FV",
    "name": "Figueiró dos Vinhos"
  },
  {
    "code": "PT-09-FA",
    "name": "Fornos de Algodres"
  },
  {
    "code": "PT-04-FE",
    "name": "Freixo de Espada à Cinta"
  },
  {
    "code": "PT-12-FR",
    "name": "Fronteira"
  },
  {
    "code": "PT-30-FU",
    "name": "Funchal"
  },
  {
    "code": "PT-05-FU",
    "name": "Fundão"
  },
  {
    "code": "PT-12-GA",
    "name": "Gavião"
  },
  {
    "code": "PT-14-GO",
    "name": "Golegã"
  },
  {
    "code": "PT-13-GO",
    "name": "Gondomar"
  },
  {
    "code": "PT-09-GO",
    "name": "Gouveia"
  },
  {
    "code": "PT-15-GR",
    "name": "Grândola"
  },
  {
    "code": "PT-09-GU",
    "name": "Guarda"
  },
  {
    "code": "PT-03-GU",
    "name": "Guimarães"
  },
  {
    "code": "PT-06-GO",
    "name": "Góis"
  },
  {
    "code": "PT-20-HO",
    "name": "Horta"
  },
  {
    "code": "PT-05-IN",
    "name": "Idanha-a-Nova"
  },
  {
    "code": "PT-08-LA",
    "name": "Lagoa"
  },
  {
    "code": "PT-20-LG",
    "name": "Lagoa"
  },
  {
    "code": "PT-08-LS",
    "name": "Lagos"
  },
  {
    "code": "PT-20-LF",
    "name": "Lajes das Flores"
  },
  {
    "code": "PT-20-LP",
    "name": "Lajes do Pico"
  },
  {
    "code": "PT-18-LA",
    "name": "Lamego"
  },
  {
    "code": "PT-10-LE",
    "name": "Leiria"
  },
  {
    "code": "PT-11-LI",
    "name": "Lisboa"
  },
  {
    "code": "PT-08-LO",
    "name": "Loulé"
  },
  {
    "code": "PT-11-LS",
    "name": "Loures"
  },
  {
    "code": "PT-11-LN",
    "name": "Lourinhã"
  },
  {
    "code": "PT-13-LO",
    "name": "Lousada"
  },
  {
    "code": "PT-06-LO",
    "name": "Lousã"
  },
  {
    "code": "PT-04-MC",
    "name": "Macedo de Cavaleiros"
  },
  {
    "code": "PT-30-MA",
    "name": "Machico"
  },
  {
    "code": "PT-20-MA",
    "name": "Madalena"
  },
  {
    "code": "PT-11-MA",
    "name": "Mafra"
  },
  {
    "code": "PT-13-MI",
    "name": "Maia"
  },
  {
    "code": "PT-18-MA",
    "name": "Mangualde"
  },
  {
    "code": "PT-09-MA",
    "name": "Manteigas"
  },
  {
    "code": "PT-13-MC",
    "name": "Marco de Canaveses"
  },
  {
    "code": "PT-10-MG",
    "name": "Marinha Grande"
  },
  {
    "code": "PT-12-MA",
    "name": "Marvão"
  },
  {
    "code": "PT-13-MT",
    "name": "Matosinhos"
  },
  {
    "code": "PT-14-MA",
    "name": "Mação"
  },
  {
    "code": "PT-01-ME",
    "name": "Mealhada"
  },
  {
    "code": "PT-16-ME",
    "name": "Melgaço"
  },
  {
    "code": "PT-17-MF",
    "name": "Mesão Frio"
  },
  {
    "code": "PT-06-MI",
    "name": "Mira"
  },
  {
    "code": "PT-06-MC",
    "name": "Miranda do Corvo"
  },
  {
    "code": "PT-04-MD",
    "name": "Miranda do Douro"
  },
  {
    "code": "PT-04-MI",
    "name": "Mirandela"
  },
  {
    "code": "PT-04-MO",
    "name": "Mogadouro"
  },
  {
    "code": "PT-18-MB",
    "name": "Moimenta da Beira"
  },
  {
    "code": "PT-15-MT",
    "name": "Moita"
  },
  {
    "code": "PT-08-MO",
    "name": "Monchique"
  },
  {
    "code": "PT-17-MB",
    "name": "Mondim de Basto"
  },
  {
    "code": "PT-12-MO",
    "name": "Monforte"
  },
  {
    "code": "PT-17-MT",
    "name": "Montalegre"
  },
  {
    "code": "PT-07-MN",
    "name": "Montemor-o-Novo"
  },
  {
    "code": "PT-06-MV",
    "name": "Montemor-o-Velho"
  },
  {
    "code": "PT-15-MN",
    "name": "Montijo"
  },
  {
    "code": "PT-16-MO",
    "name": "Monção"
  },
  {
    "code": "PT-07-MR",
    "name": "Mora"
  },
  {
    "code": "PT-18-MR",
    "name": "Mortágua"
  },
  {
    "code": "PT-02-MO",
    "name": "Moura"
  },
  {
    "code": "PT-07-MO",
    "name": "Mourão"
  },
  {
    "code": "PT-01-MU",
    "name": "Murtosa"
  },
  {
    "code": "PT-17-MU",
    "name": "Murça"
  },
  {
    "code": "PT-02-ME",
    "name": "Mértola"
  },
  {
    "code": "PT-09-ME",
    "name": "Mêda"
  },
  {
    "code": "PT-10-NA",
    "name": "Nazaré"
  },
  {
    "code": "PT-18-NE",
    "name": "Nelas"
  },
  {
    "code": "PT-12-NI",
    "name": "Nisa"
  },
  {
    "code": "PT-20-NO",
    "name": "Nordeste"
  },
  {
    "code": "PT-02-OD",
    "name": "Odemira"
  },
  {
    "code": "PT-11-OD",
    "name": "Odivelas"
  },
  {
    "code": "PT-11-OE",
    "name": "Oeiras"
  },
  {
    "code": "PT-05-OL",
    "name": "Oleiros"
  },
  {
    "code": "PT-08-OL",
    "name": "Olhão"
  },
  {
    "code": "PT-01-OA",
    "name": "Oliveira de Azeméis"
  },
  {
    "code": "PT-18-OF",
    "name": "Oliveira de Frades"
  },
  {
    "code": "PT-01-OB",
    "name": "Oliveira do Bairro"
  },
  {
    "code": "PT-06-OH",
    "name": "Oliveira do Hospital"
  },
  {
    "code": "PT-02-OU",
    "name": "Ourique"
  },
  {
    "code": "PT-14-OU",
    "name": "Ourém"
  },
  {
    "code": "PT-01-OV",
    "name": "Ovar"
  },
  {
    "code": "PT-15-PA",
    "name": "Palmela"
  },
  {
    "code": "PT-06-PS",
    "name": "Pampilhosa da Serra"
  },
  {
    "code": "PT-13-PA",
    "name": "Paredes"
  },
  {
    "code": "PT-16-PC",
    "name": "Paredes de Coura"
  },
  {
    "code": "PT-13-PF",
    "name": "Paços de Ferreira"
  },
  {
    "code": "PT-10-PG",
    "name": "Pedrógão Grande"
  },
  {
    "code": "PT-06-PC",
    "name": "Penacova"
  },
  {
    "code": "PT-13-PE",
    "name": "Penafiel"
  },
  {
    "code": "PT-18-PC",
    "name": "Penalva do Castelo"
  },
  {
    "code": "PT-05-PE",
    "name": "Penamacor"
  },
  {
    "code": "PT-18-PE",
    "name": "Penedono"
  },
  {
    "code": "PT-06-PL",
    "name": "Penela"
  },
  {
    "code": "PT-10-PN",
    "name": "Peniche"
  },
  {
    "code": "PT-17-PR",
    "name": "Peso da Régua"
  },
  {
    "code": "PT-09-PI",
    "name": "Pinhel"
  },
  {
    "code": "PT-10-PB",
    "name": "Pombal"
  },
  {
    "code": "PT-20-PD",
    "name": "Ponta Delgada"
  },
  {
    "code": "PT-30-PD",
    "name": "Ponta do Sol"
  },
  {
    "code": "PT-16-PB",
    "name": "Ponte da Barca"
  },
  {
    "code": "PT-16-PL",
    "name": "Ponte de Lima"
  },
  {
    "code": "PT-12-PS",
    "name": "Ponte de Sôr"
  },
  {
    "code": "PT-12-PA",
    "name": "Portalegre"
  },
  {
    "code": "PT-07-PO",
    "name": "Portel"
  },
  {
    "code": "PT-08-PO",
    "name": "Portimão"
  },
  {
    "code": "PT-13-PO",
    "name": "Porto"
  },
  {
    "code": "PT-10-PM",
    "name": "Porto de Mós"
  },
  {
    "code": "PT-30-PM",
    "name": "Porto Moniz"
  },
  {
    "code": "PT-30-PS",
    "name": "Porto Santo"
  },
  {
    "code": "PT-20-PC",
    "name": "Povoação"
  },
  {
    "code": "PT-20-PV",
    "name": "Praia da Vitória"
  },
  {
    "code": "PT-05-PN",
    "name": "Proença-a-Nova"
  },
  {
    "code": "PT-03-PL",
    "name": "Póvoa de Lanhoso"
  },
  {
    "code": "PT-13-PV",
    "name": "Póvoa de Varzim"
  },
  {
    "code": "PT-07-RD",
    "name": "Redondo"
  },
  {
    "code": "PT-07-RM",
    "name": "Reguengos de Monsaraz"
  },
  {
    "code": "PT-18-RE",
    "name": "Resende"
  },
  {
    "code": "PT-30-RB",
    "name": "Ribeira Brava"
  },
  {
    "code": "PT-17-RP",
    "name": "Ribeira de Pena"
  },
  {
    "code": "PT-20-RG",
    "name": "Ribeira Grande"
  },
  {
    "code": "PT-14-RM",
    "name": "Rio Maior"
  },
  {
    "code": "PT-17-SA",
    "name": "Sabrosa"
  },
  {
    "code": "PT-09-SA",
    "name": "Sabugal"
  },
  {
    "code": "PT-14-SM",
    "name": "Salvaterra de Magos"
  },
  {
    "code": "PT-18-SC",
    "name": "Santa Comba Dão"
  },
  {
    "code": "PT-30-SC",
    "name": "Santa Cruz"
  },
  {
    "code": "PT-20-SG",
    "name": "Santa Cruz da Graciosa"
  },
  {
    "code": "PT-20-SF",
    "name": "Santa Cruz das Flores"
  },
  {
    "code": "PT-01-SM",
    "name": "Santa Maria da Feira"
  },
  {
    "code": "PT-17-SM",
    "name": "Santa Marta de Penaguião"
  },
  {
    "code": "PT-30-SA",
    "name": "Santana"
  },
  {
    "code": "PT-14-SA",
    "name": "Santarém"
  },
  {
    "code": "PT-15-SC",
    "name": "Santiago do Cacém"
  },
  {
    "code": "PT-13-ST",
    "name": "Santo Tirso"
  },
  {
    "code": "PT-14-SD",
    "name": "Sardoal"
  },
  {
    "code": "PT-09-SE",
    "name": "Seia"
  },
  {
    "code": "PT-15-SX",
    "name": "Seixal"
  },
  {
    "code": "PT-18-SE",
    "name": "Sernancelhe"
  },
  {
    "code": "PT-02-SE",
    "name": "Serpa"
  },
  {
    "code": "PT-05-SE",
    "name": "Sertã"
  },
  {
    "code": "PT-15-SS",
    "name": "Sesimbra"
  },
  {
    "code": "PT-15-SE",
    "name": "Setúbal"
  },
  {
    "code": "PT-01-SV",
    "name": "Sever do Vouga"
  },
  {
    "code": "PT-08-SI",
    "name": "Silves"
  },
  {
    "code": "PT-15-SI",
    "name": "Sines"
  },
  {
    "code": "PT-11-SI",
    "name": "Sintra"
  },
  {
    "code": "PT-11-SM",
    "name": "Sobral de Monte Agraço"
  },
  {
    "code": "PT-06-SO",
    "name": "Soure"
  },
  {
    "code": "PT-12-SO",
    "name": "Sousel"
  },
  {
    "code": "PT-18-ST",
    "name": "Sátão"
  },
  {
    "code": "PT-08-SB",
    "name": "São Brás de Alportel"
  },
  {
    "code": "PT-01-SJ",
    "name": "São João da Madeira"
  },
  {
    "code": "PT-18-SJ",
    "name": "São João da Pesqueira"
  },
  {
    "code": "PT-18-SP",
    "name": "São Pedro do Sul"
  },
  {
    "code": "PT-20-SP",
    "name": "São Roque do Pico"
  },
  {
    "code": "PT-30-SV",
    "name": "São Vicente"
  },
  {
    "code": "PT-18-TB",
    "name": "Tabuaço"
  },
  {
    "code": "PT-18-TR",
    "name": "Tarouca"
  },
  {
    "code": "PT-08-TA",
    "name": "Tavira"
  },
  {
    "code": "PT-03-TB",
    "name": "Terras de Bouro"
  },
  {
    "code": "PT-14-TM",
    "name": "Tomar"
  },
  {
    "code": "PT-18-TO",
    "name": "Tondela"
  },
  {
    "code": "PT-04-TM",
    "name": "Torre de Moncorvo"
  },
  {
    "code": "PT-14-TN",
    "name": "Torres Novas"
  },
  {
    "code": "PT-11-TV",
    "name": "Torres Vedras"
  },
  {
    "code": "PT-09-TR",
    "name": "Trancoso"
  },
  {
    "code": "PT-13-TR",
    "name": "Trofa"
  },
  {
    "code": "PT-06-TA",
    "name": "Tábua"
  },
  {
    "code": "PT-01-VG",
    "name": "Vagos"
  },
  {
    "code": "PT-01-VC",
    "name": "Vale de Cambra"
  },
  {
    "code": "PT-16-VA",
    "name": "Valença"
  },
  {
    "code": "PT-13-VA",
    "name": "Valongo"
  },
  {
    "code": "PT-17-VA",
    "name": "Valpaços"
  },
  {
    "code": "PT-20-VE",
    "name": "Velas"
  },
  {
    "code": "PT-07-VN",
    "name": "Vendas Novas"
  },
  {
    "code": "PT-07-VA",
    "name": "Viana do Alentejo"
  },
  {
    "code": "PT-16-VC",
    "name": "Viana do Castelo"
  },
  {
    "code": "PT-02-VI",
    "name": "Vidigueira"
  },
  {
    "code": "PT-03-VM",
    "name": "Vieira do Minho"
  },
  {
    "code": "PT-05-VR",
    "name": "Vila de Rei"
  },
  {
    "code": "PT-08-VB",
    "name": "Vila do Bispo"
  },
  {
    "code": "PT-13-VC",
    "name": "Vila do Conde"
  },
  {
    "code": "PT-20-VP",
    "name": "Vila do Porto"
  },
  {
    "code": "PT-04-VF",
    "name": "Vila Flor"
  },
  {
    "code": "PT-11-VX",
    "name": "Vila Franca de Xira"
  },
  {
    "code": "PT-20-VC",
    "name": "Vila Franca do Campo"
  },
  {
    "code": "PT-14-VB",
    "name": "Vila Nova da Barquinha"
  },
  {
    "code": "PT-16-VN",
    "name": "Vila Nova de Cerveira"
  },
  {
    "code": "PT-03-VF",
    "name": "Vila Nova de Famalicão"
  },
  {
    "code": "PT-09-VF",
    "name": "Vila Nova de Foz Côa"
  },
  {
    "code": "PT-13-VG",
    "name": "Vila Nova de Gaia"
  },
  {
    "code": "PT-18-VP",
    "name": "Vila Nova de Paiva"
  },
  {
    "code": "PT-06-VP",
    "name": "Vila Nova de Poiares"
  },
  {
    "code": "PT-17-VP",
    "name": "Vila Pouca de Aguiar"
  },
  {
    "code": "PT-17-VR",
    "name": "Vila Real"
  },
  {
    "code": "PT-08-VS",
    "name": "Vila Real de Santo António"
  },
  {
    "code": "PT-05-VV",
    "name": "Vila Velha de Ródão"
  },
  {
    "code": "PT-03-VV",
    "name": "Vila Verde"
  },
  {
    "code": "PT-07-VV",
    "name": "Vila Viçosa"
  },
  {
    "code": "PT-04-VM",
    "name": "Vimioso"
  },
  {
    "code": "PT-04-VN",
    "name": "Vinhais"
  },
  {
    "code": "PT-18-VS",
    "name": "Viseu"
  },
  {
    "code": "PT-03-VZ",
    "name": "Vizela"
  },
  {
    "code": "PT-18-VO",
    "name": "Vouzela"
  },
  {
    "code": "PT-01-AG",
    "name": "Águeda"
  },
  {
    "code": "PT-07-EV",
    "name": "Évora"
  },
  {
    "code": "PT-01-IL",
    "name": "Ílhavo"
  },
  {
    "code": "PT-10-OB",
    "name": "Óbidos"
  }
]